import { checkRepeatConfig, checkRepeatList } from '@/services/inqueryServices'
import _ from 'lodash'
// import { isMobile } from '@/lib/device'
import { toType } from '@/lib/utils'
import i18n from '@/lib/language'

const state = {
  loading: true,
  searched: false,
  titles: {},
  list: null,
  permissions: null,
  pagination: {
    currentPage: 1,
    pageSize: 10,
    pageSizes: ['10', '20', '30', '50'],
    total: 0
  },
  searchConfig: {
    key: '',
    placeholder: '',
    value: '',
    options: []
  }
}

const getters = {
  newList (state) {
    const { list } = state
    if (!list || !list.length) return

    let data = _.cloneDeep(list)
    data.forEach(item => {
      for (let k in item) {
        if (toType(item[k]) === 'object') {
          if (!item[k].columntype) {
            if (item[k].fieldvalue === '') {
              item[k] = '- -'
            } else {
              item[k] = item[k].fieldvalue
            }
          }
        } else if (toType(item[k]) === 'string') {
          item[k] = item[k] || '- -'
        }
      }
    })
    return data
  },
  columns (state) {
    const { titles = {}, list = [] } = state
    let newArr = []
    for (let fieldkey in titles) {
      const fieldTitle = titles[fieldkey]
      let field = {}

      field.dataIndex = fieldkey
      field.title = fieldTitle

      if (fieldkey === 'contact_info_contact_mobile' || fieldkey === 'contact_info_contact_email') {
        field.width = 300
      }

      for (let item of list) {
        for (let k in item) {
          if (k === fieldkey && (item[k].columntype || toType(item[k].fieldvalue) === 'array')) {
            field.scopedSlots = { customRender: fieldkey }
          }
        }
      }
      // field.scopedSlots = { customRender: fieldkey }
      newArr.push(field)
    }

    const inquiryCheckRepeatView = state.permissions['inquiry-check-repeat-view']
    if (inquiryCheckRepeatView) {
      return [
        ...newArr,
        {
          title: i18n.t('message["79"]'),
          key: 'operation',
          width: 100,
          scopedSlots: { customRender: 'action' }
        }
      ]
    } else {
      return [
        ...newArr
      ]
    }
  }
}

const mutations = {
  SET_LOADING (state, data) {
    state.loading = data
  },
  SET_SEARCHED (state, data) {
    state.searched = data
  },
  SET_LIST_DATA (state, data) {
    state.list = data
  },
  SET_PERMISSIONS (state, data) {
    state.permissions = data
  },
  SET_TITLES (state, data) {
    state.titles = data
  },
  SET_TOTAL (state, data) {
    state.pagination.total = data
  },
  SET_SEARCH_CONFIG (state, data) {
    state.searchConfig = data
  },
  RESET_PAGINATION (state) {
    state.pagination = {
      currentPage: 1,
      pageSize: 10,
      pageSizes: ['10', '20', '30', '50'],
      total: 0
    }
  }
}

const actions = {
  async fetchSearchConfig ({ state, commit }, data) {
    const chain = await checkRepeatConfig().onSuccess(async payload => {
      state.searchConfig.options = payload

      if (payload.length) {
        state.searchConfig.key = data.repeatfieldkey || payload[0].fieldkey
        state.searchConfig.value = data.repeatfieldvalue
        state.searchConfig.placeholder = `${i18n.t('message["751"]')} ${payload[0].fieldname}`
      }

      commit('SET_SEARCH_CONFIG', state.searchConfig)
    })
    return chain
  },
  async setSearchConfig ({ state, commit }, searchConfig) {
    commit('SET_SEARCH_CONFIG', searchConfig)
  },
  clearList ({ state, commit }) {
    // commit('SET_LOADING', true)
    commit('SET_LIST_DATA', [])
    commit('SET_LOADING', true)
    commit('SET_SEARCHED', false)
  },
  async fetchList ({ state, commit }) {
    commit('SET_LIST_DATA', [])
    commit('SET_LOADING', true)
    const chain = await checkRepeatList()
      .onSuccess(async (payload, raw = {}) => {
        const { permissions = {} } = raw
        const { data = {}, title = [] } = payload
        const { count = 0, list = [] } = data

        commit('SET_LOADING', false)
        commit('SET_LIST_DATA', list)
        commit('SET_TITLES', title)
        commit('SET_TOTAL', parseInt(count))
        commit('SET_PERMISSIONS', permissions)

        commit('SET_SEARCHED', true)
      })
      .onFail(() => {
        commit('SET_LOADING', false)
      })
    return chain
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
